var map = {
	"./2009-2010pdf-61c62920330eb1d7769530118271b107.pdf": 97325,
	"./2010-2011pdf-eb294fed405830fb0c0b6b041a48c00c.pdf": 19980,
	"./2011-2012pdf-2546b9562f5768ff53a6252f837c8cda.pdf": 18648,
	"./2012-2013pdf-d43f15b6f94f7387df17dfb5a0032ce1.pdf": 35081,
	"./2013-2014-pdf-69a9dfd0ffe5f27a3d7ee5b531cd7fd9.pdf": 6717,
	"./2014-2015-pdf-0130dde0113db8555aecd0cc358f890b.pdf": 65530,
	"./2020-2021pdf-f799cb63d15b6c6ad11cfdfe63df19c1.pdf": 38388,
	"./2021-2022pdf-c88058e16db1efad4f254fedf0a0292a.pdf": 10732,
	"./L - 2024-25.pdf": 15482,
	"./L-2015-16pdf-2e11f5fea531dba29f67eff8c323e408.pdf": 87686,
	"./L-2016-17pdf-5bc0e0c536e3cca911db55d1748a4d98.pdf": 11853,
	"./L-2017-18pdf-b2ca2cce194dcc6a972265724be9334f.pdf": 37747,
	"./L-2018-2019-PDF-fbdd4be87c618d69a8fb7fcb27eed218.pdf": 52096,
	"./L-2019-20-up-to-JulyPDF-17059782a587afa573bb0ff0956cceba.pdf": 8024,
	"./L-2019-20-up-to-Macrh-20PDF-74f800e49c6c1e5412be3c77af9aa312.pdf": 65871,
	"./LSQ_2024_2025compressedpdf-094f0d2e2e273703448d0f04cb6bf21e.pdf": 93166,
	"./Lok-Sabha-2022-23cpdf-6057e3cb4fb4a4f0517e37ed79cf0a33.pdf": 90209,
	"./Lok-Sabha_2023_2024PDF-96864346e6faa93837c2c022d512e454.pdf": 61324,
	"./Parliament Question 2019-20.pdf": 50805,
	"./Parliament Question 2020-21.pdf": 43060
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78695;